import { useState, useCallback, useEffect } from 'react';
import styles from './ProjectCard.module.css'

export default function ProjectCard({img, title, url}) {
    // const displayContent = () => {
    //     if (img) {
    //         return (
    //             <img src={img} alt="Projet Dés Aventures" height="100%" width="100%"/>
    //         );
    //     } else {
    //         return (
    //             <video controls width="100%" height="100%" preload="true">
    //                 <source src={videoWebm} type="video/webm" />
    //                 <source src={videoMp4} type="video/mp4" />
    //                 <p>Votre navigateur ne prend pas en charge la vidéo.</p>
    //             </video>
    //         )
    //     }
    // }

    // const [bounds, setBounds] = useState();

    const rotateMouse = useCallback((e) => {
        // const mouseX = e.clientX;
        // const mouseY = e.clientY;
        // const leftX = mouseX - bounds.x;
        // const topY = mouseY - bounds.y;
        // const center = {
        //     x: leftX - bounds.width / 2 / 10,
        //     y: topY - bounds.height / 2 / 30
        // }
        // console.log(leftX - bounds.width / 2);
        // const distance = Math.sqrt(center.x**2 + center.y**2);
        const card = e.target;
        const title = card.children[0];
        console.log(title);

        // console.log(center.y / 100);
        // console.log(Math.log(distance * 2));
        card.style.transform = 'scale3d(1.07, 1.07, 1.07)';
        card.style.filter = 'blur(2px)';
        
        title.style.display = 'block ';
        // card.style.transform = `
        // scale3d(1.07, 1.07, 1.07)
        // rotate3d(
        //     ${center.y / 10 * 2},
        //     ${-center.x / 10 * 2},
        //     0,
        //     ${Math.log(distance * 2) * 4}deg
        // )`;
        // card.style.transform = `
        // scale(1.07)
        // rotateY(${center.x}deg)
        // `;
    }, [])
    const mouseOnCard = e => {
        // setBounds(e.target.getBoundingClientRect());
        // document.addEventListener('mousemove', rotateMouse);
        const card = e.target.closest('a');
        const title = card.nextElementSibling;

        card.style.transform = 'scale3d(1.07, 1.07, 1.07)';
        card.style.filter = 'blur(2px)';
        
        title.style.opacity = '1';
    }
    // useEffect(() => {
    //     console.log(bounds)
    //     if (bounds) {
    //     }
    // }, [bounds])

    const mouseNotOnCard = e => {
        // document.removeEventListener('mousemove', rotateMouse);
        const card = e.target.closest('a');
        const title = card.nextElementSibling;

        card.style.transform = '';
        card.style.filter = 'blur(0)';
        
        title.style.opacity = '0';
    }



    return (
        <div className={styles.card} >
            <a href={url} className={styles.linkCard} style={{backgroundImage: `url(${img})`}} >
            <span>{title}</span>
            </a>
        </div>
        // <>
        //     <button onClick={handleCard} id="closeButton" className="z-10" aria-label="Fermer"><i className="fa-solid fa-x"></i></button>
        //     <div className="video">
        //         {displayContent()}
        //     </div>
        //     <a href={link} target="_blank">{title}<i className="fa-solid fa-link px-2"></i></a>
        //     <p className={styles.content}>{content}</p>
        //     <p className={styles.skills}>{skills}</p>
        // </>
    )
}